import { AutogenModelEdirecoveryList, AutogenRowEdirecoveryList } from "./autogen/AutogenModelEdirecoveryList";

export class ModelEdirecoveryList extends AutogenModelEdirecoveryList<RowEdirecoveryList> {
	constructor() {
		super(RowEdirecoveryList);
	}
}

export class RowEdirecoveryList extends AutogenRowEdirecoveryList {
}